import './index.css'

import React from 'react'
import SearchFilters from 'components/search-filters'
import SearchWrapper from 'containers/SearchWrapper'
export default class Search extends React.Component<any> {
  render(): React.ReactNode {
    return (
      <SearchWrapper>
        {/* @ts-expect-error props are passed from `SearchWrapper` */}
        <SearchFilters />
      </SearchWrapper>
    )
  }
}
